import styled from 'styled-components/macro';

export const TextInput = styled.input.attrs({
  type: 'text',
})<any>`
  display: block;
  width: 80%;
  margin-left: 8px;
  max-width: 800px;
  font-size: 16px;
  &::placeholder {
    font-size: 16px;
    color: ${props => props.theme.colors.black[100]};
    opacity: 0.6;
    font-family: 'Work Sans, sans-serif';
    font-weight: 500;
  }
  border: ${({ error, theme }) =>
    error ? `1px solid ${theme.colors.danger[100]}` : 'solid 1px #dfe3e6'};
  height: 40px;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 4px;
  transition:
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  &:focus {
    color: #495057;
    background-color: #fff;
    border-color: ${({ theme }) => theme.colors.primary[100]}
    outline: 0;
  }
`;
